import React, { useEffect } from "react";
import { makeStyles, Text } from "@fluentui/react-components";
import { LocalizeContextProps, withLocalize } from "react-localize-redux";
import { NewformaCheckbox } from "../../../_base/Checkbox";

const useStyles = makeStyles({
    row: {
        display: "flex",
        alignItems: "center",
        gap: "4px",
    },
    label: {
        fontSize: "12px",
    },
});

export interface RequireLoginSectionProps extends LocalizeContextProps {
    checked: boolean;
    disabled: boolean;
    isInactive: boolean;
    onChange: (_ev: any, data: any) => void;
}

const RequireLoginSection: React.FC<RequireLoginSectionProps> = (props) => {
    const styles = useStyles();
    const { checked, disabled, onChange, translate, isInactive } = props;

    const lastIsInactiveRef = React.useRef(isInactive);

    useEffect(() => {
        if (lastIsInactiveRef.current && !isInactive && !disabled && checked) onChange(null, { checked: false });

        lastIsInactiveRef.current = isInactive;
        if (isInactive) return;

        if (disabled && !checked) {
            onChange(null, { checked: true });
            return;
        }
    }, [isInactive, disabled, onChange]);

    return (
        <div className={styles.row}>
            <NewformaCheckbox
                checked={checked}
                onChange={onChange}
                disabled={disabled}
                dataTestId="require-login-checkbox"
            />
            <Text className={styles.label}>{translate("SHARED.MOREOPTIONS.CHECKBOX_EXCHANGE") as string}</Text>
        </div>
    );
};

export default withLocalize(RequireLoginSection) as React.ComponentType<
    Omit<RequireLoginSectionProps, keyof LocalizeContextProps>
>;
